import type { FC } from 'react';
import React, { useContext } from 'react';

import { RicosViewerContext } from './../../ricos-context';
import type { GalleryData } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { NodeViewRenderer, NodeViewRendererProps } from './../../ricos-types';

import { GALLERY_TYPE } from '../types';
import { GalleryViewer } from './gallery-viewer';

const Gallery: FC<NodeViewRendererProps> = ({ node, nodeIndex, NodeViewContainer }) => {
  const { relValue, anchorTarget, config, seoMode, helpers } = useContext(RicosViewerContext);
  return (
    <NodeViewContainer node={node} nodeIndex={nodeIndex}>
      <GalleryViewer
        componentData={node.galleryData || ({} as GalleryData)}
        nodeId={node.id}
        settings={config[GALLERY_TYPE]}
        relValue={relValue}
        anchorTarget={anchorTarget}
        seoMode={seoMode}
        helpers={helpers}
      />
    </NodeViewContainer>
  );
};

const GalleryRenderer: NodeViewRenderer = ({ node, ...props }) => {
  return <Gallery key={node.id} node={node} {...props} />;
};

export default GalleryRenderer;
